<template>
  <div class="setting-module">


    <div>
      <!--<b-button @click="modalShow = !modalShow">Open Modal</b-button>-->

      <!--<b-modal id="editprofile" hide-footer title="ویرایش پروفایل">

        <div class="d-block text-center">
          <h3>Hello From My Modal!</h3>
        </div>

      </b-modal>-->


      <b-modal id="editprofile" hide-footer>
        <template #modal-header="{ close }">
          <!-- Emulate built in modal header close button action -->
          <!--<b-button size="sm" variant="outline-danger" @click="close()">
            Close Modal
          </b-button>-->
          <h5>ویرایش پروفایل</h5>
        </template>

        <template #default="{ hide }">
          <p>Modal Body with button</p>
          <b-button @click="hide()">Hide Modal</b-button>
        </template>

        <!--<template #modal-footer="{ ok, cancel, hide }">
          <b>Custom Footer</b>
          &lt;!&ndash; Emulate built in modal footer ok and cancel button actions &ndash;&gt;
          <b-button size="sm" variant="success" @click="ok()">
            OK
          </b-button>
          <b-button size="sm" variant="danger" @click="cancel()">
            Cancel
          </b-button>
          &lt;!&ndash; Button with custom close trigger value &ndash;&gt;
          <b-button size="sm" variant="outline-secondary" @click="hide('forget')">
            Forget it
          </b-button>
        </template>-->

      </b-modal>


    </div>

    <div class="title">
      <p>تنظیمات</p>
    </div>
    <div class="container">
      <div class="setting-list-profile">
        <div class="item" @click="editProfileModal">
          <pencil-icon />
          <div class="text">
            <h6>ویرایش اطلاعات حساب</h6>
            <p>
              نام، نام خانوادگی و نام نمایشی شما از این قسمت قابل ویرایش میباشد.
            </p>
          </div>
        </div>

        <router-link tag="div" to="/profile/avatar" class="item" >
         <account-edit-outline-Icon />
          <div class="text">
            <h6>
              تغییر تصویر آواتار
            </h6>
            <p>از این قسمت می‌توانید برای خود یک تصویر پروفایل انتخاب کنید.</p>
          </div>
        </router-link>

        <div class="item" @click="rulesModal">
         <shield-check-icon />
          <div class="text">
            <h6>
              قوانین و شرایط استفاده
            </h6>
            <p>مشاهده متن کامل قوانین برنامه</p>
          </div>
        </div>


        <div class="item" @click="paymentinfoModal">
          <shield-check-icon />
          <div class="text">
            <h6>
              توضیحات خرید‌ها و پرداخت‌ها
            </h6>
            <p>دستور العمل روش‌های خرید و پرداخت در برنامه</p>
          </div>
        </div>


        <div class="item" @click="supportModal">
         <face-Agent-icon />
          <div class="text">
            <h6>
              پشتیبانی
            </h6>
            <p>پاسخ به سوالات شما و ارتباط با مدیران</p>
          </div>
        </div>

        <a style="text-decoration: none;color:#000000" :href="`https://wa.me/+989190344943?text=${encodeURI('پشتیبانی')}`" class="item">
          <face-Agent-icon />
          <div class="text">
            <h6>
              شکایت
            </h6>
            <p>پاسخ به سوالات شما و ارتباط با مدیران</p>
          </div>
        </a>


        <div class="item" v-on:click="logout">
          <cancel-icon fill-color="#e80202" />
          <div class="text">
            <h6>
              خروج
            </h6>
            <p>خروج از حساب کاربری</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer"></div>
    <!-- <RuleModal v-if="showRule" /> -->
  </div>
</template>

<script>

import CancelIcon from 'vue-material-design-icons/Cancel.vue';
import PencilIcon from 'vue-material-design-icons/Pencil.vue';
import AccountEditOutlineIcon from 'vue-material-design-icons/AccountEditOutline.vue';

import ShieldCheckIcon  from 'vue-material-design-icons/ShieldCheck.vue';

import FaceAgentIcon from 'vue-material-design-icons/FaceAgent.vue';

export default {
  data() {
    return {

    };
  },
  components:{
    CancelIcon,
    PencilIcon,
    AccountEditOutlineIcon,
    ShieldCheckIcon,
    FaceAgentIcon
  },
  methods:{
    logout(){

      /*this.$toastr.s(
          "This Message From Toastr Plugin\n You can access this plugin : <font color='yellow'>this.$toastr</font>"
      );*/
      window.localStorage.removeItem("kishoto-store");
      window.localStorage.removeItem("token");

      this.$toast.open({
        message: 'شما با موفقیت از حساب کاربری خود خارج شدید',
        type: 'success',
        // all of other options may go here
      });

      //this.$router.push("/");
      setTimeout(()=>{
        window.open("/","_self");
      },2000);
      //this.$swal('Hello Vue world!!!');
    },
    editProfileModal(){
      this.$emit("editUserModal",true);
      //this.$bvModal.show("editprofile")
    },
      supportModal(){
      this.$emit("supportModal",true);
    },

    paymentinfoModal(){
      this.$emit("paymentinfoModal",true);
    },
    rulesModal(){
      this.$emit("rulesModal",true);
    }



  }

};
</script>

<style lang="scss" scoped>
.setting-module {
  width: 100%;
  margin-top: 60px;
  position: relative;
  .title {
    width: 100%;
    height: 2px;
    background-color: blue;
    position: relative;
    p {
      padding: 10px;
      background-color: red;
      width: 100px;
      text-align: center;
      margin-bottom: 0;
      position: absolute;
      font-family: "sansb";
      background: #fff;
      right: 10%;
      top: -23px;
      font-size: 21px;
    }
  }
  .setting-list-profile {
    width: 100%;
    height: auto;
    margin-top: 50px;
    text-align: right;
    direction: rtl;
    .item {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-bottom: 30px;
      .text {
        margin-right: 10px;
        p {
          font-family: "sans";
          font-size: 12px;
          margin-bottom: 0;
          color: #757575;
        }
        h6 {
          font-family: "sansb";
          font-size: 15px;
        }
      }
      .icon {
        width: 30px;
        span {
          color: #2640d6;
        }
      }

      span.material-design-icon{
        margin-left: 8px;
        svg {
          color: #2640d6;
          font-size: 24px;
        }
      }
      span.cancel-icon{
        svg {
          color: red;
        }
      }

      .red {
        width: 30px;
        span {
          color: red;
        }
      }

      &:last-child {
        margin: 0;
      }
    }
  }

  .footer {
    width: 100%;
    height: 200px;
    background-image: url("~@/assets/img/main/profile_footer_image.png");
    background-position: center;
    background-size: cover;
  }

  .rule-modal {
  }
}
</style>
